/**
 * Created by imranexpt on 15/03/2018.
 */
(function() {
    /** @ngInject */
    function termsPageController($scope, $state){
        $scope.request = false;
        $scope.skip_accept = false;

        if(settings.skip_general){
            $scope.skip_accept = true;
            $scope.booking.terms.general = true;
        }
        $scope.next = function(){
            if(!$scope.booking.hasErrors(true)){
                $scope.request = true;

                $scope.booking.save().success(function(response){
                    if(response.success !== true || !_.has(response, 'booking')){
                        alert(response.errors);
                        $scope.request = false;
                        return false;
                    }
                    var bookingObj = null;
                    if(response.booking && response.booking.id > 0){
                        var d1 = moment(response.booking.date);
                        var d2 = moment();
                        bookingObj = {
                            'regDate': moment().format('YYYY-MM-DD HH:mm'),
                            'bookingDate': response.booking.date,
                            'bookingTime': response.booking.time_formatted,
                            'quantity': response.booking.amount,
                            'totalAmount': $scope.booking.getProductsTotal(),
                            'daysAhead': d1.diff(d2, 'days'),
                            'products' : _.size($scope.booking.booking_products),
                            'meal' : $scope.booking.meal.name,
                            'amount' : $scope.booking.amount,
                            'date' : response.booking.date,
                            'time' : $scope.booking.time,
                            'averageValue' : $scope.booking.meal.avg_gtm_price,
                            'totalValue' : ($scope.booking.meal.avg_gtm_price*$scope.booking.amount)
                        };
                        }

                    updateWidgetStep('Reservation-Completed', bookingObj);
                    //});
                    if(response.booking && response.booking.id > 0) {
                        $scope.booking.initFromDbObj(response.booking);
                        $scope.date = $scope.booking.getDate('YYYY-MM-DD');

                        if(typeof(dataLayer) !== 'undefined' && !testDt){
                            dataLayer.push({
                                //'event' : 'purchase',
                                'ecommerce': {
                                    'purchase': {
                                        'actionField' : {
                                            'id': response.booking.id,
                                            'revenue' : restaurant_gtm_price,
                                        },
                                        'products': [
                                            {
                                                'name': $scope.booking.meal.name,       // Name or ID is required.
                                                'brand': restaurant_name,
                                                'category': 'Bordsbokning',
                                                'quantity': $scope.booking.amount,
                                                'firstname': $scope.booking.firstname,
                                                'lastname': $scope.booking.lastname,
                                                'email' : $scope.booking.email,
                                                'date': $scope.date,
                                                'dimension15': $scope.booking.amount,
                                                'dimension16': $scope.booking.time,
                                                'dimension17': $scope.booking.getDate('MMDDYY'),
                                                'time': $scope.booking.time,
                                                'waitlist' : $scope.booking.waitlist ? 'Y' : 'N',
                                                'meal': $scope.booking.meal.name,
                                                'price': restaurant_gtm_price
                                            }
                                        ]
                                    }
                                }
                            });
                            if(typeof(ga) !== 'undefined'){
                                ga('ec:addProduct', {
                                    'id': response.booking.id,// Product ID (string).
                                    'name': 'Bordsbokning #' + response.booking.id, // Product name (string).
                                    'category':'Bordsbokning', // Product category (string).
                                    'brand': restaurant_name,
                                    'variant': $scope.booking.meal.name,
                                    'price': restaurant_gtm_price,
                                    'quantity': 1,
                                    'dimension15': $scope.booking.amount,
                                    'dimension16': $scope.booking.time,
                                    'dimension17': $scope.booking.getDate('MMDDYY')
                                });
                            }
                        }
                        if(typeof(window.parent) !== 'undefined') {
                            window.parent.postMessage("reservationSuccess", "*");
                        }
                        if(typeof(dataLayerBokabord) !== 'undefined'){
                            //ga('BokabordGoalTracking.send', 'event', 'WidgetReservations', 'TableReserved','Restaurant-' + restaurant_name);
                            dataLayerBokabord.push({
                                'event' : 'Final-Confirmation',
                                'restaurant' : restaurant_name
                            });
                        }

                        if(response.booking.status === 0) {
                            $state.go('payinwidget', {}, {location: false});
                        }else{
                            //if(settings.is_bb_ref === true && window.self === window.top){
                            //	window.location = 'https://www.bokabord.se/thankyou';
                            //	return;
                            //}


                            window.setTimeout(function () {
                                window.location = '/reservation/booking/?code=' + response.booking.short_code + '&new=1';
                            }, 1000);
                        }
                    }
                });
            }
        };
        $scope.canGoNext = function(){ return $scope.booking.terms.general === true && !$scope.request; };
        $scope.$on("$viewContentLoaded", function() {
            updateWidgetStep('Terms');
            //add checkout event
            if(typeof(dataLayer) !== 'undefined' && !testDt){
                //console.log("Adding DL event",dataLayer);
                dataLayer.push({
                    'event': 'checkout',
                    'ecommerce': {
                        'checkout': {
                            'products': [
                                {
                                    'name': $scope.booking.meal.name,       // Name or ID is required.
                                    'brand': restaurant_name,
                                    'category': 'Bordsbokning',
                                    //'id': response.booking.id,
                                    'amount': $scope.booking.amount,
                                    'firstname': $scope.booking.firstname,
                                    'lastname': $scope.booking.lastname,
                                    'email' : $scope.booking.email,
                                    'date': $scope.date,
                                    'time': $scope.booking.time,
                                    'waitlist' : $scope.booking.waitlist ? 'Y' : 'N',
                                    'meal': $scope.booking.meal.name,
                                    'price': restaurant_gtm_price
                                }
                            ]
                        }
                    }
                });
                if(typeof(ga) !== 'undefined'){
                    ga('ec:addProduct', {
                        //'id': response.booking.id,// Product ID (string).
                        'name': 'Bordsbokning ', //+ response.booking.id, // Product name (string).
                        'category':'Bordsbokning', // Product category (string).
                        'brand': restaurant_name,
                        'variant': $scope.booking.meal.name,
                        'price': restaurant_gtm_price,
                        'quantity': 1,
                        'dimension15': $scope.booking.amount,
                        'dimension16': $scope.booking.time,
                        'dimension17': $scope.booking.getDate('MMDDYY')
                    });
                }
            }
        });

    }
    angular.module("Waiteraid").controller("termsCtrl", termsPageController);
})();
